import { useState, useEffect, useCallback } from 'react';
import { getAccounts, getDepartments, getJobTitles } from '../api/services/common.service';

export const useCOAOptions = (corpId) => {
    const [expenseCoaOptions, setExpenseCoaOptions] = useState([]);
    const [payableCoaOptions, setPayableCoaOptions] = useState([]);
    const [jobTitleOptions, setJobTitleOptions] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [coaLoading, setCoaLoading] = useState(false);
    const [payableCoaLoading, setPayableCoaLoading] = useState(false);
    const [deptLoading, setDeptLoading] = useState(false);
    const [jobLoading, setJobLoading] = useState(false);

    useEffect(() => {
        if (!corpId || corpId === "000000000000000000000000000000000000") {
            setExpenseCoaOptions([]);
            setPayableCoaOptions([]);
            setDepartmentOptions([]);
            setJobTitleOptions([{ value: "ADD_NEW", label: "Add New", Name: "Add New" }]);
            return;
        }

        const loadAllOptions = async () => {
            setCoaLoading(true);
            setPayableCoaLoading(true);
            setDeptLoading(true);
            setJobLoading(true);

            try {
                const [coaRes, deptRes, jobRes] = await Promise.all([
                    getAccounts(corpId),
                    getDepartments(),
                    getJobTitles()
                ]);

                setExpenseCoaOptions(coaRes || []);
                setPayableCoaOptions(coaRes || []);
                setDepartmentOptions(deptRes || []);
                setJobTitleOptions([{ value: "ADD_NEW", label: "Add New", Name: "Add New" }, ...(jobRes || [])]);
            } catch (err) {
                console.error("Failed to load options:", err);
            } finally {
                setCoaLoading(false);
                setPayableCoaLoading(false);
                setDeptLoading(false);
                setJobLoading(false);
            }
        };

        loadAllOptions();
    }, [corpId]);

    const loadJobTitles = useCallback(async () => {
        setJobLoading(true);
        let titles = [];
        try {
            titles = await getJobTitles();
            setJobTitleOptions([{ value: "ADD_NEW", label: "Add New", Name: "Add New" }, ...titles]);
        } finally {
            setJobLoading(false);
        }
        return titles;
    }, []);

    const loadAccounts = useCallback(async () => {
        setCoaLoading(true);
        setPayableCoaLoading(true);
        let accounts = [];
        try {
            accounts = await getAccounts(corpId, "000000000000000000000000000000000000", true);
            setExpenseCoaOptions(accounts || []);
            setPayableCoaOptions(accounts || []);
        } catch (err) {
            console.error("Failed to reload accounts:", err);
        } finally {
            setCoaLoading(false);
            setPayableCoaLoading(false);
        }
        return accounts || [];
    }, [corpId]);

    const isLoading = deptLoading || jobLoading || coaLoading || payableCoaLoading;

    return {
        expenseCoaOptions,
        payableCoaOptions,
        departmentOptions,
        jobTitleOptions,
        isLoading,
        loadJobTitles,
        loadAccounts
    };
};